import { Box, Stack, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const KycBannerContainer = styled(Stack)(({ theme }) => ({
  width: '80%',
  margin: '0 auto',
  marginTop: theme.spacing(4),
  zIndex: 1,
  backgroundColor: alpha(theme.palette.primary.main, 0.2),
  borderRadius: theme.spacing(6),
  padding: `${theme.spacing(3.5)} ${theme.spacing(6)}`,
  marginBottom: theme.spacing(4),

  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  flexWrap: 'wrap',

  [theme.breakpoints.up('md')]: {
    borderRadius: theme.spacing(26.25),
  },
}));

export const KycContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
}));

export const KycIconTitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    marginRight: 'auto',
  },
}));

export const KycDescriptionText = styled('div')(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,

  [theme.breakpoints.down('sm')]: {
    width: '50%',
    textAlign: 'center',
    marginRight: 'auto',
  },
}));

export const KycButtonContainer = styled(Box)(({ theme }) => ({
  width: 'auto',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    order: 3,
  },

  [theme.breakpoints.up('sm')]: {
    order: 'unset',
  },
}));

export const KycAnimationWrapper = styled('div')(() => ({
  width: '100%',
}));
